import { z } from 'zod';

export const clanParamsSchema = z.object({
    tab: z
        .enum(['completed', 'created'])
        .default('completed')
        .catch('completed'),
});

export const defaultClanSearchParams = clanParamsSchema.parse({});

export type clanParamsType = z.infer<typeof clanParamsSchema>;
